import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { KreFormModule, Default_CODE } from "@kre-form/core";
import { IONIC_KreFORM_CONFIG, FIELD_TYPE_COMPONENTS } from "./ui-ionic.config";
import { IonKreFormAttributes } from "./kre-form.attributes";
import { IonKreFormFloat } from "./kre-form.float";
import { validationConfig } from "./validation.config";
import { KreFormLookUpEmployee } from "./components/employee/index.component";
import { KreFormFieldIonSelectComponent } from "./components/select_component";
import { KreFormFieldIonTextI18Component } from "./components/texti18_component";
import { KreFormFieldIonTagsComponent } from "./components/tags_component";
import { KreFormIonDialogService } from "./tools/dialog.service";
import { KreFormIonToastService } from "./tools/toast.service";
//私有的
const entryComponent = [
  KreFormFieldIonSelectComponent,
  KreFormFieldIonTextI18Component,
  KreFormFieldIonTagsComponent,
];
@NgModule({
  declarations: [
    FIELD_TYPE_COMPONENTS,
    IonKreFormAttributes,
    IonKreFormFloat,
    KreFormLookUpEmployee,
    ...entryComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    KreFormModule.forChild(IONIC_KreFORM_CONFIG),
    KreFormModule.forRoot(validationConfig),
  ],
  entryComponents: [...entryComponent, KreFormLookUpEmployee],
  exports: [
    IonKreFormAttributes,
    IonKreFormFloat,
    KreFormLookUpEmployee,
    ...entryComponent,
  ],

  providers: [KreFormIonDialogService, KreFormIonToastService],
})
export class KreFormIonicModule {}
